import { render, staticRenderFns } from "./autoSum.vue?vue&type=template&id=05f886bc"
import script from "./autoSum.vue?vue&type=script&lang=js"
export * from "./autoSum.vue?vue&type=script&lang=js"
import style0 from "./autoSum.vue?vue&type=style&index=0&id=05f886bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports